exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qr-font p{\r\n  font-size: 0.9rem;\r\n  margin-bottom: 2px !important;\r\n  font-weight: bold;\r\n}\r\n\r\n.my-icon{\r\n  font-size: 1.8rem !important;\r\n}\r\n\r\n.my-button{\r\n  margin-left: 10px !important;\r\n  padding: 2px 0px !important;\r\n}\r\n\r\n.my-no-margin{\r\n  margin: 0px !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/ingresoproduccion/ingresoproduccion.component.css
// module id = ../../../../../src/app/components/ingresoproduccion/ingresoproduccion.component.css
// module chunks = main